import { render, staticRenderFns } from "./medicineDetail.vue?vue&type=template&id=21a66c7b&scoped=true&"
import script from "./medicineDetail.vue?vue&type=script&lang=js&"
export * from "./medicineDetail.vue?vue&type=script&lang=js&"
import style0 from "./medicineDetail.vue?vue&type=style&index=0&id=21a66c7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a66c7b",
  null
  
)

export default component.exports